var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4142 2.99985C10.6332 2.2188 9.36684 2.2188 8.58579 2.99985L5.29289 6.29274C4.90237 6.68327 4.90237 7.31643 5.29289 7.70696C5.68342 8.09748 6.31658 8.09748 6.70711 7.70696L9 5.41406V11.9999C9 12.5522 9.44772 12.9999 10 12.9999C10.5523 12.9999 11 12.5522 11 11.9999V5.41406L13.2929 7.70696C13.6834 8.09748 14.3166 8.09748 14.7071 7.70696C15.0976 7.31643 15.0976 6.68327 14.7071 6.29274L11.4142 2.99985ZM3 9.99988C3.55228 9.99988 4 10.4476 4 10.9999V14.9999C4 15.5522 4.44772 15.9999 5 15.9999H15C15.5523 15.9999 16 15.5522 16 14.9999V10.9999C16 10.4476 16.4477 9.99988 17 9.99988C17.5523 9.99988 18 10.4476 18 10.9999V14.9999C18 16.6567 16.6569 17.9999 15 17.9999H5C3.34315 17.9999 2 16.6567 2 14.9999V10.9999C2 10.4476 2.44772 9.99988 3 9.99988Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.7463ff940ce43a2c068145752b9975ec.svg";
export { ForwardRef as ReactComponent };